function validController(controller) {
  return Boolean(controller && typeof controller.stop === "function");
}

export function createMediaCoordinator() {
  const controllers = new Set();
  let activeController = null;

  const register = (controller) => {
    if (!validController(controller)) {
      throw new TypeError("Cada medio debe exponer un método stop().");
    }

    controllers.add(controller);
    return () => {
      controllers.delete(controller);
      if (activeController === controller) activeController = null;
    };
  };

  const activate = (controller) => {
    if (!controllers.has(controller)) register(controller);
    if (activeController === controller) return;

    activeController = controller;
    controllers.forEach((candidate) => {
      if (candidate !== controller) candidate.stop({ reason: "another-media" });
    });
  };

  const release = (controller) => {
    if (activeController === controller) activeController = null;
  };

  const stopAll = () => {
    activeController = null;
    controllers.forEach((controller) => controller.stop({ reason: "stop-all" }));
  };

  return Object.freeze({
    activate,
    register,
    release,
    stopAll,
    get activeController() {
      return activeController;
    },
  });
}
